import { create } from 'zustand';

type NewResponsesStatus = 'initial' | 'shouldShow' | 'showing' | 'hidden';
interface AssignedClusterStore {
  targetClusterName: string | null;
  setTargetClusterName: (targetClusterName: string | null) => void;
  setShouldShow: (show: boolean) => void;
  show: boolean;
  newResponsesStatus: NewResponsesStatus;
  setNewResponsesStatus: (newResponsesStatus: NewResponsesStatus) => void;
  setAreNewResponsesVisible: (areNewResponsesVisible: boolean) => void;
  pulseNewResponsesIntoView: boolean;
  setPulseNewResponsesIntoView: (shouldPulseNewResponses: boolean) => void;
}

export const useAssignedClusterStore = create<AssignedClusterStore>((set) => ({
  targetClusterName: null,
  setTargetClusterName(targetClusterName) {
    set(() => ({ targetClusterName, show: Boolean(targetClusterName) }));
  },
  setShouldShow(show: boolean) {
    set(() => ({ show }));
  },
  show: false,
  pulseNewResponsesIntoView: false,
  setPulseNewResponsesIntoView(shouldPulseNewResponses) {
    set(() => ({ pulseNewResponsesIntoView: shouldPulseNewResponses }));
  },
  newResponsesStatus: 'initial',
  setNewResponsesStatus(newResponsesStatus) {
    set(() => ({ newResponsesStatus }));
  },
  setAreNewResponsesVisible(areNewResponsesVisible) {
    const newState = areNewResponsesVisible ? 'showing' : 'hidden';
    set(() => ({ newResponsesStatus: newState }));
  },
}));
